import React, { Component } from 'react';
import {
	Col, Row, Container, Card, CardImg, CardBody,
} from 'reactstrap';
import BeneficiaryProgramCard from '../../cards/beneficiaryProgramCard';
import RightArrow from '../../icons/rightArrowSmall';
import getConfig from 'next/config';

const config = getConfig().publicRuntimeConfig;

export default class BeneficiaryPanel extends Component {

	constructor(props) {
		super(props);
		this.state = { loadVideo: false };
	}

	render() {
		const { title, programs, viewAll, session, width, theme} = this.props;

		return (
			<Container className="panel-padding">
				<Row>
					<Col xs="12" sm="12" md="4" lg="6" className="p-0">
						<h2 style={{ marginBottom: '2rem' }}>
							Support a beneficiary directly
							<img
								className="hide-for-mobile homepage-new-start-image"
								src={`${config.cdnUrl}/static/images/home/homepage-new-badge.svg`}
								alt=""
							/>
						</h2>
					</Col>
					<Col xs="12" sm="12" md="4" lg="6" style={{ textAlign: 'right' }}>
						<a
							href={viewAll}
							className="ml-auto no-hover-a hide-for-mobile"
							style={{ fontSize: '0.875rem', color: '#444444' }}
						>
							<span
								className=" viewall-for-mobile"
								style={{ paddingRight: '6px' }}
								onClick={() => {
									if (window.eventDispatcher) {
										window.eventDispatcher.dispatchEvent(
											'beneficiary-panel-viewAll',
											{},
											{ amplitude: true }
										);
									}
								}}
							>
								View All
							</span>{' '}
							<RightArrow />
						</a>
					</Col>
				</Row>
				<Row>
					{programs.map((program, index) => (
						<BeneficiaryProgramCard
							program={program}
							key={index}
							position={index + 1}
							session={session}
							lazyLoadImage={true}
							theme={theme}
						/>
					))}
				</Row>
				<Row>
					<a
						href={viewAll}
						className="ml-auto no-hover-a hide-for-desktop"
						style={{ fontSize: '0.875rem', color: '#444444' }}
					>
						<span
							className=" viewall-for-mobile"
							style={{ paddingRight: '6px' }}
							onClick={() => {
								if (window.eventDispatcher) {
									window.eventDispatcher.dispatchEvent(
										'beneficiary-panel-viewAll',
										{},
										{ amplitude: true }
									);
								}
							}}
						>
							View All
						</span>{' '}
						<RightArrow />
					</a>
				</Row>

				<style jsx global>
					{`
						.beneficiary-panel-icon {
							height: 21px;
						}
						.homepage-new-start-image {
							height: 1.5rem;
							padding-left: 1rem;
						}
						@media (max-width: 768px) {
							.viewall-for-mobile {
								padding-bottom: 1rem !important;
							}
						}
					`}
				</style>
			</Container>
		);
	}
}
